module.exports = __webpack_public_path__ + "media/images/review/ico-new-review-6f5d2eec623f2aea10a56b6ab0934142.svg";